export default __webpack_public_path__ + "static/media/reglogin-bg-ms.4d17a416.webp";